import React from 'react'
import { Nav, Navbar, NavDropdown, Form, FormControl } from 'react-bootstrap';
import {
    NavBarWrapper,
    IconWrapper
} from './Header.style.js'
import Logo from '../../images/logo.svg'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons"
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons"



const Header = () => {
    return (
        <NavBarWrapper>
            <Navbar expand="lg">
                <Navbar.Brand href="https://www.staples.com/"><img src={Logo} alt='logo' height="24px" width='134px' /></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="">
                        <NavDropdown title="Products" id="basic-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown title="Deals" id="basic-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown title="Services" id="basic-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                    <Form inline>
                        <div className="wrapper-search">
                        <FormControl type="text" placeholder="Search" className="mr-sm-2 search-bar" />
                        <span className="search-icon">  <FontAwesomeIcon icon={faSearch}/></span>
                        </div>
                        <IconWrapper>
                            <div className="nav-icons text"><span>SIGN</span>IN</div>
                            <span className="nav-icons"><FontAwesomeIcon icon={faQuestionCircle} color='#fff' /></span>
                            <span className="nav-icons"><FontAwesomeIcon icon={faShoppingCart} color='#fff' /></span>
                        </IconWrapper>


                    </Form>
                </Navbar.Collapse>
            </Navbar>
        </NavBarWrapper>
    )
}

export default Header
